// src/theme/colors.js
export const sweetRed = {
  main: "#e53935",
  light: "#f6685e",
  softBg: "#fff5f5",
  border: "#ffcdd2",
  hover: "#d32f2f",
};

export const sweetBlue = {
  main: "#1976d2",
  light: "#42a5f5",
  softBg: "#f0f8ff",
  border: "#bbdefb",
  hover: "#1565c0",
};

export const purple = {
  main: "#800080",
};

export const brown = {
  main: "#800080",
};

// src/theme/colors.js

export const beramourSecondary = {
  main: "#d76213", // darker version of original base
  light: "#ce93d8", // lighter hue
  softBg: "#f8f0fb", // soft background tint
  border: "#e1bee7", // border color
  hover: "#6a1b9a", // even deeper tone for hover
};
